import { gql, TypedDocumentNode } from '@common/hooks';
import {
  ScheduleHealthSnapshotQueryCgResponse,
  ScheduleHealthSnapshotQueryVariables,
} from '@common/graphql';

// Feeds the Schedule Health Strip with the per-unit KPI slice that the
// `scheduleReview` resolver derives from BalancerRun.kpis. Only the
// snapshotSummary field is requested here; the grid (roles, weeks, etc.)
// is fetched by the calendar via its own query against the same resolver.
// Apollo merges both responses on the shared cache entry.
//
// currentSummary is the live "current" KPI slice (recomputed server-side from the
// output snapshot). The "Your edits" delta is derived client-side (current − autoBalanced).
export const SCHEDULE_HEALTH_SNAPSHOT_QUERY: TypedDocumentNode<
  ScheduleHealthSnapshotQueryCgResponse,
  ScheduleHealthSnapshotQueryVariables
> = gql`
  query ScheduleHealthSnapshot($balancerRunId: ID!, $organizationUnitId: ID!) {
    scheduleReview(
      balancerRunId: $balancerRunId
      organizationUnitId: $organizationUnitId
    ) {
      snapshotSummary {
        preBalance {
          fillRate
          loadBalance
          fteUtilization
          preferenceMatch
        }
        autoBalanced {
          fillRate
          loadBalance
          fteUtilization
          preferenceMatch
        }
      }
      currentSummary {
        fillRate
        loadBalance
        fteUtilization
        preferenceMatch
      }
    }
  }
`;
